// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"22a0512f","102":"5ba5cb69","458":"001b39b9","607":"ed80def2"}[chunkId] + ".chunk.css";
};